function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPourPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 90,
    viewBox: "0 0 21.166666 23.812501",
    id: "svg20973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-273.18749)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.21950619,
      strokeOpacity: 1
    },
    d: "m 0,273.1875 h 21.16667 v 7.93749 L 10.58334,296.99999 0,281.12499 Z",
    id: "rect4518-85-9-8-1-0-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#4e79a7",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.19358627,
      strokeOpacity: 1
    },
    d: "m 1.32291,274.51041 h 18.52083 v 5.99722 l -9.26041,14.11112 -9.26042,-14.11112 z",
    id: "rect4518-85-9-8-1-0-9-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.24187078,
      strokeOpacity: 1
    },
    d: "m 13.49374,283.33874 c 0,1.6999 -1.30305,3.07792 -2.91041,3.07792 -1.607389,0 -2.91042,-1.37802 -2.91042,-3.07792 0,-1.69989 2.04549,-5.65333 2.91042,-5.65333 0.86492,0 2.91041,3.95344 2.91041,5.65333 z",
    id: "path4678-5-9-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPourPoint);
export default __webpack_public_path__ + "static/media/icon-pour-point.e900a51872b5110e94440d6a6aef7362.svg";
export { ForwardRef as ReactComponent };